import React, {
    useEffect,
    useState,
    useRef,
    useContext,
    useCallback,
    Fragment,
  } from "react";
  import ReactDOM from "react-dom";
  import { useLocation, useNavigate } from "react-router-dom";
  import sanityClient from "../../client.js";
  import "./project.styles.scss";
  
  import { PortableText } from "@portabletext/react";
  import SanityMuxPlayer from "sanity-mux-player";
  import imageUrlBuilder from "@sanity/image-url";
  import { useMediaQuery } from 'react-responsive'
  import { isSafari } from 'react-device-detect';

  import ReactPlayer from 'react-player'

  import {Autoplay, Navigation, Pagination} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { BsArrowLeft } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { GrClose } from "react-icons/gr";
import { AiFillPlayCircle } from "react-icons/ai";

import { MouseContext } from "../../context/mouse-context"

  const builder = imageUrlBuilder(sanityClient);
  
  function urlFor(source) {
    return builder.image(source);
  }
  
const VideoPlayer = ({pauseCheck, videoAsset})=>{
  // console.log(videoAsset);
  const {cursorChangeHandler} = useContext(MouseContext);
  
  const [isPlaying, setIsPlaying] = useState(false)
  const video = useRef(null)

  useEffect(()=>{
    // console.log(pauseCheck)
    if(!pauseCheck && isPlaying){
      video.current.video.current.pause()
      setIsPlaying(false)
    }
  },[pauseCheck])

  const videoClickHandler = ()=>{

    if (isPlaying){
      video.current.video.current.pause()
      setIsPlaying(false)
    }else{
      video.current.video.current.play()
      setIsPlaying(true)
    }
    
  }

  if (!videoAsset) return<></>
  return (
    <div className="video-player-wrapper">
      {!isSafari ? 
      <div
        className={`video-player-controls ${isPlaying ? 'hide-controls' :''}`}
        onMouseEnter={() => cursorChangeHandler("active")}
        onMouseLeave={() => cursorChangeHandler("")}
        onClick={()=>videoClickHandler()}
      >
        <AiFillPlayCircle/>
      </div>
      :''
      }

      <SanityMuxPlayer
        onClick={()=>videoClickHandler()}
        ref={video}
        assetDocument={videoAsset}
        autoload={true}
        className={'video-player'}
        loop={false}
        playsInline={true}
        muted={false}
        showControls={true}
        // playing={true}
        poster={`https://image.mux.com/${videoAsset.playbackId}/thumbnail.jpg?time=0&width=${window.innerWidth}`}
        // poster={true} // defaults to true, an URL can be provided to override the Mux asset thumbnail
        />
    </div>
  )
}

  
  const Project = ({content, currentProjectNav}) => {

    const navigationPrevRef = useRef()
    const navigationNextRef = useRef()
    const navigationPrevRefVideo = useRef()
    const navigationNextRefVideo = useRef()
    const navigationPrevRefExtraVideo = useRef()
    const navigationNextRefExtraVideo = useRef()

    const navigationPrevRefPhase2Video = useRef()
    const navigationNextRefPhase2Video = useRef()
    const navigationNextRefPhase2Images = useRef()
    const navigationPrevRefPhase2Images = useRef()

    const navigationPrevRefPhase3Video = useRef()
    const navigationNextRefPhase3Video = useRef()
    const navigationNextRefPhase3Images = useRef()
    const navigationPrevRefPhase3Images = useRef()

    const {cursorChangeHandler} = useContext(MouseContext);
    const isNarrow = useMediaQuery({ query: '(max-width: 1100px)' })

    const navigate = useNavigate();

    const projectCloseHandler = ()=>{
      navigate('/')
    }

    const customComponent = {      
      marks: {
        link: ({children, value}) => {
          return (
            <a
            onMouseEnter={() => cursorChangeHandler("active")}
            onMouseLeave={() => cursorChangeHandler("")}
            href={value.href} target={'_blank'}>
              {children}
            </a>
          )
        },
      },
    }

    if(!content) return<></>
    return (
      <div className={"project-wrapper"}>
        <div className='project-meta'>
          <div className="project-meta-title title-font">
            {content.title}
          </div>
          <div className="project-meta-subtitle">
            <div className="title-font">Client</div>
            <div className="project-meta-value" >{content.client}</div>
          </div>
          <div className="project-meta-subtitle">
          <div className="title-font">Role</div>
            <div className="project-meta-value">{content.role}</div>
          </div>
        </div>

        {content.template == 'Montblanc_RED' ?

        // –––––––––––––––––––––––––––––––––––––––––––––––––––– MONTBLANC RED ––––––––––––––––––––––––––––––––––––––– //

        <>
        <div className='project-info'>
        
        {'challenge' in content ?
          <div className="project-info-section">
            <div className="project-info-label title-font">{'challengeTitle' in content ? content.challengeTitle : 'Idea' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.challenge}
              components={customComponent}
              // components={/* optional object of custom components to use */}
            />
            </div>
          </div>
          :''}

          {'insight' in content ?
          
          <div className="project-info-section">
            <div className="project-info-label title-font">{'insightTitle' in content ? content.insightTitle : 'Insight' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.insight}
              components={customComponent}
            />
            </div>
          </div>
          :''}

          {'idea' in content ?
          <div className="project-info-section">
            <div className="project-info-label title-font"> {'ideaTitle' in content ? content.ideaTitle : 'Idea' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.idea}
              components={customComponent}
            />
            </div>
          </div>
          :''}

        </div>
       
          <div className="project-info-section">
          <div className="project-info-label title-font">Phase 1:</div>
          <div className="project-info-value" >
          <PortableText
            value={content.phase1Text}
            components={customComponent}
            // components={/* optional object of custom components to use */}
          />
          </div>
        </div>

        <div className='project-videos'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRefVideo.current,
              nextEl: navigationNextRefVideo.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRefVideo.current;
                swiper.params.navigation.nextEl = navigationNextRefVideo.current;
          }}
          // width={'100%'}
          autoHeight={false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 2}
          pagination={isNarrow ? true : false}
          spaceBetween={isNarrow ? 0 : 20}
          centeredSlides={isNarrow ? true : false}
          allowTouchMove={isNarrow}
        >
          {content.videoAssets.map(videoAsset =>{
            // console.log(videoAsset)
            return <SwiperSlide
            // style={{
            //   height: (window.innerHeight - 200),
            //   width: ((window.innerHeight - 200) / 1.5625)}}
            className="video-swiper-slide"  key={videoAsset._key}>
              <div
              style={{
                // height: videoAsset.asset.data.aspect_ratio == '9:16' ? (window.innerHeight - 200) : ((window.innerHeight - 200) / 1.5625),
                width: isNarrow ? '100%' : ((window.innerHeight - 300) / 1.5625)
              }}
              className="video-swiper-slide-video">
                <VideoPlayer videoAsset={videoAsset.asset}/>
              </div>
              <div className="video-caption-wrapper">
              {videoAsset.caption}
              </div>
            </SwiperSlide>
          })}
          
        </Swiper>
        <div className="prev-arrow"
        onMouseEnter={() => cursorChangeHandler("active")}
        onMouseLeave={() => cursorChangeHandler("")}
        ref={navigationPrevRefVideo} >
            <BsArrowLeft/>
          </div>
          <div className="next-arrow" 
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationNextRefVideo} ><BsArrowRight/></div>
        </div>

        <div className='project-images'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRef.current,
              nextEl: navigationNextRef.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
          }}

          autoHeight={isNarrow ? true : false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 'auto'}
          pagination={isNarrow ? true : false}
          // centeredSlides={true}
          // height={window.innerHeight - 120}
          spaceBetween={isNarrow ? 20 : 0}
          // pagination={{
          //   clickable: true,
          // }}
        >
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="prev-arrow" ref={navigationPrevRef} >
            <BsArrowLeft/>
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="next-arrow" ref={navigationNextRef} >
            <BsArrowRight/></div>

          {content.images.map(image=>{
            return <SwiperSlide className="project-swiper-slide" key={image._key}>
              {/* <div className="project-image-wrapper"> */}
                <img src={urlFor(image.asset).height(window.innerHeight).url()} />
              {/* </div> */}
              <div className="project-caption-wrapper">
                {image.caption}
              </div>
            </SwiperSlide>
          })}
          
        </Swiper>
        </div>

        {/* // –––––––––––––––––––––––– PHASE 2 –––––––––––––––––––––––– */}
          <div className="project-info-section">
            <div className="project-info-label title-font">Phase 2:</div>
            <div className="project-info-value" >
            <PortableText
              value={content.phase2Text}
              components={customComponent}
            />
            </div>
          </div>

        <div className='project-videos'>

          <Swiper
              navigation={{
                prevEl: navigationPrevRefPhase2Video.current,
                nextEl: navigationNextRefPhase2Video.current,
              }}
            onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRefPhase2Video.current;
                  swiper.params.navigation.nextEl = navigationNextRefPhase2Video.current;
            }}
            // width={'100%'}
            autoHeight={false}
            loop={true}
            modules={[Navigation, Pagination]}
            slidesPerView={isNarrow ? 1 : 2}
            pagination={isNarrow ? true : false}
            spaceBetween={isNarrow ? 0 : 20}
            centeredSlides={isNarrow ? true : false}
            allowTouchMove={isNarrow}
          >
            {content.phase2VideoAssets.map(videoAsset =>{
              // console.log(videoAsset)
              return <SwiperSlide
              // style={{
              //   height: (window.innerHeight - 200),
              //   width: ((window.innerHeight - 200) / 1.5625)}}
              className="video-swiper-slide"  key={videoAsset._key}>
                <div
                style={{
                  // height: videoAsset.asset.data.aspect_ratio == '9:16' ? (window.innerHeight - 200) : ((window.innerHeight - 200) / 1.5625),
                  width: isNarrow ? '100%' : ((window.innerHeight - 300) / 1.5625)
                }}
                className="video-swiper-slide-video">
                  <VideoPlayer videoAsset={videoAsset.asset}/>
                </div>
                <div className="video-caption-wrapper">
                  {videoAsset.caption}
                </div>
              </SwiperSlide>
            })}
            
          </Swiper>
          <div className="prev-arrow"
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationPrevRefPhase2Video} >
              <BsArrowLeft/>
            </div>
          <div className="next-arrow" 
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationNextRefPhase2Video} ><BsArrowRight/>
          </div>
        </div>

        <div className='project-images'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRefPhase2Images.current,
              nextEl: navigationNextRefPhase2Images.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRefPhase2Images.current;
                swiper.params.navigation.nextEl = navigationNextRefPhase2Images.current;
          }}

          autoHeight={isNarrow ? true : false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 'auto'}
          pagination={isNarrow ? true : false}
          allowTouchMove={isNarrow}
          // centeredSlides={true}
          // height={window.innerHeight - 120}
          spaceBetween={isNarrow ? 20 : 0}
          // pagination={{
          //   clickable: true,
          // }}
        >
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="prev-arrow" ref={navigationPrevRefPhase2Images} >
            <BsArrowLeft/>
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="next-arrow" ref={navigationNextRefPhase2Images} >
            <BsArrowRight/></div>

          {content.phase2Images.map(image=>{
            return <SwiperSlide className="project-swiper-slide" key={image._key}>
              {/* <div className="project-image-wrapper"> */}
                <img src={urlFor(image.asset).height(window.innerHeight).url()} />
              {/* </div> */}
              <div className="project-caption-wrapper">
                {image.caption}
              </div>
            </SwiperSlide>
          })}
          
        </Swiper>
        </div>

        {/* // –––––––––––––––––––––––– PHASE 3 –––––––––––––––––––––––– */}
        <div className="project-info-section">
            <div className="project-info-label title-font">Phase 3:</div>
            <div className="project-info-value" >
            <PortableText
              value={content.phase3Text}
              components={customComponent}
            />
            </div>
          </div>

        <div className='project-videos'>

          <Swiper
              navigation={{
                prevEl: navigationPrevRefPhase3Video.current,
                nextEl: navigationNextRefPhase3Video.current,
              }}
            onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRefPhase3Video.current;
                  swiper.params.navigation.nextEl = navigationNextRefPhase3Video.current;
            }}
            // width={'100%'}
            autoHeight={false}
            loop={true}
            modules={[Navigation, Pagination]}
            slidesPerView={isNarrow ? 1 : 2}
            pagination={isNarrow ? true : false}
            spaceBetween={isNarrow ? 0 : 20}
            centeredSlides={isNarrow ? true : false}
            allowTouchMove={isNarrow}
          >
            {content.phase3VideoAssets.map(videoAsset =>{
              // console.log(videoAsset)
              return <SwiperSlide
              // style={{
              //   height: (window.innerHeight - 200),
              //   width: ((window.innerHeight - 200) / 1.5625)}}
              className="video-swiper-slide"  key={videoAsset._key}>
                <div
                style={{
                  // height: videoAsset.asset.data.aspect_ratio == '9:16' ? (window.innerHeight - 200) : ((window.innerHeight - 200) / 1.5625),
                  width: isNarrow ? '100%' : ((window.innerHeight - 300) / 1.5625)
                }}
                className="video-swiper-slide-video">
                  <VideoPlayer videoAsset={videoAsset.asset}/>
                </div>
                <div className="video-caption-wrapper">
                  {videoAsset.caption}
                </div>
              </SwiperSlide>
            })}
            
          </Swiper>
          <div className="prev-arrow"
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationPrevRefPhase3Video} >
              <BsArrowLeft/>
            </div>
          <div className="next-arrow" 
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationNextRefPhase3Video} ><BsArrowRight/>
          </div>
        </div>

        <div className='project-images'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRefPhase3Images.current,
              nextEl: navigationNextRefPhase3Images.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRefPhase3Images.current;
                swiper.params.navigation.nextEl = navigationNextRefPhase3Images.current;
          }}

          autoHeight={isNarrow ? true : false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 'auto'}
          pagination={isNarrow ? true : false}
          allowTouchMove={isNarrow}
          // centeredSlides={true}
          // height={window.innerHeight - 120}
          spaceBetween={isNarrow ? 20 : 0}
          // pagination={{
          //   clickable: true,
          // }}
        >
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="prev-arrow" ref={navigationPrevRefPhase3Images} >
            <BsArrowLeft/>
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="next-arrow" ref={navigationNextRefPhase3Images} >
            <BsArrowRight/></div>

          {content.phase3Images.map(image=>{
            return <SwiperSlide className="project-swiper-slide" key={image._key}>
              {/* <div className="project-image-wrapper"> */}
                <img src={urlFor(image.asset).height(window.innerHeight).url()} />
              {/* </div> */}
              <div className="project-caption-wrapper">
                {image.caption}
              </div>
            </SwiperSlide>
          })}
          
        </Swiper>
        </div>


        </>
        :
        //----––––––––––––––––––––––––––––––––––––––– DEFAULT ––––––––––––––––––––––––––––––––––––––––––––––––––//
        <>
        
        <div className='project-videos'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRefVideo.current,
              nextEl: navigationNextRefVideo.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRefVideo.current;
                swiper.params.navigation.nextEl = navigationNextRefVideo.current;
          }}

          // width={'100%'}
          autoHeight={false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 2}
          pagination={isNarrow ? true : false}
          spaceBetween={isNarrow ? 0 : 20}
          centeredSlides={isNarrow ? true : false}
          allowTouchMove={isNarrow}
        >
          {content.videoAssets.map(videoAsset =>{
            // console.log(videoAsset)
            return <SwiperSlide className="video-swiper-slide"  key={videoAsset._key}>
              {({ isActive }) => (
              <>
                <div
                style={{
                  // height: videoAsset.asset.data.aspect_ratio == '9:16' ? (window.innerHeight - 200) : ((window.innerHeight - 200) / 1.5625),
                  width: isNarrow ? '100%' : ((window.innerHeight - 300) / 1.5625)
                }}
                className="video-swiper-slide-video">
                  <VideoPlayer pauseCheck={isActive} videoAsset={videoAsset.asset}/>
                </div>
                <div className="video-caption-wrapper">
                {videoAsset.caption}
                </div>
              </>
              )}
            </SwiperSlide>
          })}
          
        </Swiper>
        <div className="prev-arrow"
        onMouseEnter={() => cursorChangeHandler("active")}
        onMouseLeave={() => cursorChangeHandler("")}
        ref={navigationPrevRefVideo} >
            <BsArrowLeft/>
          </div>
          <div className="next-arrow" 
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationNextRefVideo} ><BsArrowRight/></div>
        </div>

        <div className='project-info'>
        
        {'challenge' in content ?
          <div className="project-info-section">
            <div className="project-info-label title-font">{'challengeTitle' in content ? content.challengeTitle : 'Challenge' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.challenge}
              components={customComponent}
              // components={/* optional object of custom components to use */}
            />
            </div>
          </div>
          :''}

          {'insight' in content ?
          
          <div className="project-info-section">
            <div className="project-info-label title-font">{'insightTitle' in content ? content.insightTitle : 'Insight' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.insight}
              components={customComponent}
            />
            </div>
          </div>
          :''}

          {'idea' in content ?
          <div className="project-info-section">
            <div className="project-info-label title-font">{'ideaTitle' in content ? content.ideaTitle : 'Idea' }</div>
            <div className="project-info-value" >
            <PortableText
              value={content.idea}
              components={customComponent}
            />
            </div>
          </div>
          :''}

        </div>

        <div className='project-images'>
        <Swiper
            navigation={{
              prevEl: navigationPrevRef.current,
              nextEl: navigationNextRef.current,
            }}
          onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
          }}

          autoHeight={isNarrow ? true : false}
          loop={true}
          modules={[Navigation, Pagination]}
          slidesPerView={isNarrow ? 1 : 'auto'}
          pagination={isNarrow ? true : false}
          allowTouchMove={isNarrow}
          // centeredSlides={true}
          // height={window.innerHeight - 120}
          spaceBetween={isNarrow ? 20 : 0}
          // pagination={{
          //   clickable: true,
          // }}
        >
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="prev-arrow" ref={navigationPrevRef} >
            <BsArrowLeft/>
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          className="next-arrow" ref={navigationNextRef} >
            <BsArrowRight/></div>

          {content.images.map(image=>{
            return <SwiperSlide className="project-swiper-slide" key={image._key}>
              {/* <div className="project-image-wrapper"> */}
                <img src={urlFor(image.asset).height(window.innerHeight).url()} />
              {/* </div> */}
              <div className="project-caption-wrapper">
                {image.caption}
              </div>
            </SwiperSlide>
          })}
          
        </Swiper>
        </div>

        {'textExtra' in content ?
        <div className="project-info-section">
            {/* <div className="project-info-label title-font">Idea</div> */}
            <div className="project-info-value" >
            <PortableText
              value={content.textExtra}
              components={customComponent}
            />
            </div>
          </div>

          :''
          }

        {'extraVideoAssets' in content ?
        <>
          <div className='project-videos'>
          <Swiper
              navigation={{
                prevEl: navigationPrevRefExtraVideo.current,
                nextEl: navigationNextRefExtraVideo.current,
              }}
            onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRefExtraVideo.current;
                  swiper.params.navigation.nextEl = navigationNextRefExtraVideo.current;
            }}
            // width={'100%'}
            autoHeight={false}
            loop={true}
            modules={[Navigation, Pagination]}
            slidesPerView={isNarrow ? 1 : 2}
            pagination={isNarrow ? true : false}
            spaceBetween={isNarrow ? 0 : 20}
            centeredSlides={isNarrow ? true : false}
            allowTouchMove={isNarrow}
          >
            {content.extraVideoAssets.map(videoAsset =>{
              // console.log(videoAsset)
              return <SwiperSlide
              // style={{
              //   height: (window.innerHeight - 200),
              //   width: ((window.innerHeight - 200) / 1.5625)}}
              className="video-swiper-slide"  key={videoAsset._key}>
                <div
                style={{
                  // height: videoAsset.asset.data.aspect_ratio == '9:16' ? (window.innerHeight - 200) : ((window.innerHeight - 200) / 1.5625),
                  width: isNarrow ? '100%' : ((window.innerHeight - 300) / 1.5625)
                }}
                className="video-swiper-slide-video">
                  <VideoPlayer videoAsset={videoAsset.asset}/>
                </div>
                <div className="video-caption-wrapper">
                  {videoAsset.caption}
                </div>
              </SwiperSlide>
            })}
            
          </Swiper>
          <div className="prev-arrow"
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          ref={navigationPrevRefExtraVideo} >
              <BsArrowLeft/>
            </div>
            <div className="next-arrow" 
            onMouseEnter={() => cursorChangeHandler("active")}
            onMouseLeave={() => cursorChangeHandler("")}
            ref={navigationNextRefExtraVideo} ><BsArrowRight/></div>
          </div>
          </>
          :
          ''
        }
        </>
        }


        <div className="project-bottom-nav">
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          onClick={()=>{window.location.href = `/${currentProjectNav.prevSlug}` }}
          className={`project-bottom-nav-prev ${currentProjectNav.prevSlug == null ? 'nav-faded' : ''}`}>
            Previous 
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          onClick={()=>{navigate(`/`)}}
          className="project-bottom-nav-close">
            Close 
          </div>
          <div
          onMouseEnter={() => cursorChangeHandler("active")}
          onMouseLeave={() => cursorChangeHandler("")}
          onClick={()=>{window.location.href = `/${currentProjectNav.nextSlug}` }}
          className={`project-bottom-nav-next ${currentProjectNav.nextSlug == null ? 'nav-faded' : ''}`}>
            Next 
          </div>
        </div>
      </div>
    );
  };
  
  export default Project;
  